import React, {useState, useEffect} from "react";
import info from "./Union-3.svg";
import styles from "./CancelSubscription.module.css";
import Button from "../../../../../common-ui-components/components/button/Button";
import { notify } from "common-ui-components/components/notification/Notification";
import Failure from "common-ui-components/components/notification/templates/Failure";
import {useNavigate} from 'react-router-dom';
import EM_API from "common-ui-components/components/utils/API"
import Success from "../../../../../common-ui-components/components/notification/templates/Success";
import { goBack } from "app/common/redirects/Redirects";
import { useRestrictionChecker } from "common-ui-components/components/restrictionUI/RestrictionChecker";

const cancelKey="SUBSCRIPTIONS_CANCEL";

function CancelSubscription({dueDate, onClose }) 
{
    const history = useNavigate();
    const items = [
        "Too expensive",
        "Not using enough",
        "Missing features I need",
        "Technical issues",
        "Taking a temporary break",
    ];

    const [checkedItems, setCheckedItems] = useState({});
    const [comments, setComments] = useState("");
    const [isCancelling, setIsCancelling] = useState(false);

    const { checkRestriction }=useRestrictionChecker();
    
    const handleChange = (e) => {
        const { value, checked } = e.target;
        setCheckedItems((prev) => ({
            ...prev,
            [value]: checked,
        }));
    };

    const cancelSubscription = async () => {
        if(checkRestriction(cancelKey))
            return;
        setIsCancelling(true);

        const selectedReasons = Object.keys(checkedItems)
            .filter(key => checkedItems[key]);

        let cancellationReason = selectedReasons.join(", ");
        if (comments) {
            cancellationReason += (selectedReasons.length > 0 ? " - " : "") + comments;
        }

        try {
            const response = await EM_API.post('payment/cancel', { reason: cancellationReason });

            if (response.status) {
                notify(<Success>Your subscription has been cancelled successfully.</Success>);
            } else {
                notify(<Failure>{response.status.message || "Failed to cancel subscription."}</Failure>);
            }

        } catch (error) {
            console.error("Cancellation failed:", error);
            notify(<Failure>An unexpected error occurred. Please try again.</Failure>);

        } finally {
            setIsCancelling(false);
            onClose?.();
        }
    };

    const keepSubscription = () => {
        goBack(history,3);
        onClose?.();
    };

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <p className={styles.title}>Cancel Subscription</p>
                <p className={styles.subtitle}>
                    We are sorry to see you go. Help us understand why you are cancelling.
                </p>
            </header>

            <section className={styles.notice}>
                <img src={info} alt="info" className={styles.infoIcon} />
                <p className={styles.noticePara}>
                    Your Subscription will remain active until <strong>{dueDate}</strong>. You will lose
                    access to Standard features after this date.
                </p>
            </section>

            <main className={styles.reasons}>
                <p className={styles.label}>What is your main reason for cancelling?</p>
                <div className={styles.checkboxList}>
                    {items.map((item) => (
                        <label key={item} className={styles.checkboxItem}>
                            <input
                                type="checkbox"
                                value={item}
                                checked={checkedItems[item] || false}
                                onChange={handleChange}
                                className={styles.checkbox}
                            />
                            {item}
                        </label>
                    ))}
                </div>
            </main>

            <section className={styles.comments}>
                <p className={styles.label}>Comments, if any:</p>
                <textarea
                    className={styles.textarea}
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    placeholder="Please describe your reason for downgrade."
                />
            </section>

            <footer className={styles.actionsWrapper}>
                <div className={styles.actions}>
                    <Button
                        variant="danger"
                        onClick={cancelSubscription}
                        disabled={isCancelling}
                    >
                        {isCancelling ? "Cancelling..." : "Cancel Subscription"}
                    </Button>
                    <Button variant="allow" onClick={keepSubscription}>Keep Subscription</Button>
                </div>
            </footer>
        </div>
    );
}

export default CancelSubscription;